<template>
  <div class="recommand">
    <van-nav-bar
      title="我的代保管"
      left-arrow
      @click-left="onClickLeft"
    />
    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options" class="page_scroll">
      <div class="noDataTip notice" v-if="recomendInfo.length===0">
        <dl>
          <dt></dt>
          <dd style="width:100%;text-align:center;">暂无数据</dd>
        </dl>
      </div>
      <ul class="recommand-list">
        <block v-for="(item, index) in recomendInfo" :key="index">
          <li>
            <span v-if="item.custody_time_two!=null" style="height: 20px;line-height: 20px;font-weight: bold">第一只</span>
            <span style="width: 100%;">
               订单编号：   {{item.order_num}}
            </span>
            <span style="width: 100%;">代保管截止时间:   {{item.custody_time}}</span>
            <span style="width: 100%;">被采集人姓名:   {{item.gather_name}}</span>
          </li>

          <li v-if="item.custody_time_two!=null">
            <span if="item.custody_time_two!=null" style="height: 20px;line-height: 20px;font-weight: bold">第二只</span>
            <span style="width: 100%;">
               订单编号：   {{item.order_num}}
            </span>
            <span style="width: 100%;">代保管截止时间:   {{item.custody_time}}</span>
            <span style="width: 100%;">被采集人姓名:   {{item.gather_name}}</span>
          </li>
        </block>

      </ul>
    </cube-scroll>
  </div>
</template>
<script>
import moment from 'moment'
import Vue from 'vue'
import { NavBar } from 'vant'
Vue.use(NavBar)
export default {
  name: 'findReportin',
  data () {
    return {
      user_id: localStorage.getItem('user_id'),
      userType: this.$route.params.userType,
      recomendInfo: [],
      items: [],
      options: {},
      order_id: this.$route.params.report_id
    }
  },
  created () {
    this.$loading.show()
    this.getInit()
  },
  methods: {

    // 返回
    onClickLeft() {
      this.$router.go(-1)
    },
    // doctorOrders
    getInit () {
      this.$http.api.mybaoguan({
        user_id: this.user_id
      }).then( result => {
        this.$loading.hide()
        this.recomendInfo = [...result]
        this.recomendInfo = this.recomendInfo.map(item => {
          return Object.assign({}, item, {    //时间格式化
            custody_time: moment(item.custody_time).format('YYYY-MM-DD')
          })
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .page_scroll{
    top: 1.3rem;
  }
  .recommand{
    width: 100%;
    overflow: hidden;
    .recommand-list {
      padding: 0 10px;
      width: 100%;
      box-sizing: border-box;
      margin-top: 15px;
      li{
        width: 100%;
        padding: 10px 0px;
        background: #fff;
        margin-bottom: 5px;
        border-radius: 1px;
        border:1px solid rgba(0, 0, 0, 0.1);
        span{

          width: 100%;
          display: inline-block;
          height: 26px;
          line-height: 26px;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
          padding-left: 20px;
          &:nth-child(1){

          }
        }
      }
    }
  }
  .noDataTip{
    width: 100%;
    text-align: center;
    padding-top: 30px;
  }
</style>
